import { Badge, Button } from "@repo/components";
import { useTranslation } from "@repo/i18n";
import { css } from "@repo/styled-system/css";
import { useActingStaff } from "./ActingStaffProvider";

/**
 * The attribution badge: when a staff member is acting (via the PIN quick-switch), the header shows
 * who — the visible half of the R5/R8 attribution seam. "Exit" clears the acting staff back to the
 * device principal. Renders nothing when no one is acting.
 */
export function ActingStaffBadge() {
  const { actingStaff, setActingStaff } = useActingStaff();
  const { t } = useTranslation();
  if (!actingStaff) return null;
  return (
    <span className={css({ display: "inline-flex", alignItems: "center", gap: "2" })}>
      <Badge variant="solid">{t("shell.acting.badge", { name: actingStaff.displayName })}</Badge>
      <Button size="xs" variant="ghost" onClick={() => setActingStaff(null)}>
        {t("shell.acting.exit")}
      </Button>
    </span>
  );
}
